module.exports = __webpack_public_path__ + "img/gh (3).f2f424a7.png";